<template>
    <el-upload
        class="avatar-uploader"
        action="https://"
        :http-request="
            file => {
                uploadFile(file);
            }
        "
        :show-file-list="false"
        :before-upload="beforeAvatarUpload"
        accept="image/*"
    >
        <img v-if="imageUrl" :src="imageUrl" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
</template>

<script>
export default {
    props: ['detailContent'],
    watch: {
        detailContent(newVal) {
            this.imageUrl = { ...newVal }.pictureBase64 || '';
            this.imageSuffix = { ...newVal }.uploadFileSuffix || '';
        }
    },
    data() {
        return {
            imageUrl: '',
            // 图片后缀
            imageSuffix: ''
        };
    },
    methods: {
        // 限制上传文件类型以及大小
        beforeAvatarUpload(file) {
            const types = ['image/jpeg', 'image/jpg', 'image/bmp', 'image/png'];
            const isImage = types.includes(file.type);
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isImage) {
                this.$message.error('上传图⽚只能是 JPG、JPEG、gif、bmp、PNG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isImage && isLt2M;
        },
        // 转64
        getBase64(file) {
            return new Promise(function(resolve, reject) {
                let reader = new FileReader();
                let imgResult = '';
                reader.readAsDataURL(file);
                reader.onload = function() {
                    imgResult = reader.result;
                };
                reader.onerror = function(error) {
                    reject(error);
                };
                reader.onloadend = function() {
                    resolve(imgResult);
                };
            });
        },
        uploadFile({ file }) {
            this.getBase64(file).then(res => {
                this.imageUrl = res;
            });
            this.imageSuffix = file.type.split('/')[1];
            this.$emit('uploadFn', true);
        }
    }
};
</script>

<style lang="scss" scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
</style>
